import { RecordPatch, RecordSlot } from '#record/model';
import { DeepPartial, utils } from 'apprise-core/utils';
import { priorTrxauthzType } from './constants';

export type PriorTrxAuthPatch = RecordPatch<typeof priorTrxauthzType> 

export type PriorTrxAuthzs = RecordSlot & {

    authzs: PriorTrxAuthz[]

  
}

export type PriorTrxAuthz = {

    timestamp: string
    
    from: string
    to: string
    
    authorisationNumber?: string
    authorisingEntity?: string

}


// minimal skeleton for missing slots.
export const newPriorTrxAuthzSlot = () => {

    const partials : DeepPartial<PriorTrxAuthzs> = {

        id: utils().mint('PTRX'),
        authzs: []

    } 

    return partials as PriorTrxAuthzs
}